import { useState, useEffect } from 'react';

import type { MenuData } from 'src/types/types';
import { fetchMenuData } from 'src/api/menu';

type State =
  | { status: 'loading' }
  | { status: 'error'; message: string }
  | { status: 'success'; data: MenuData };

export const useMenuData = (): State => {
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchMenuData();
        setState({ status: 'success', data });
      } catch (err) {
        setState({ status: 'error', message: (err as Error).message });
      }
    };

    load();
  }, []);

  return state;
};
